// TotalCostOfProject.js
import React from "react";
import { Box, MenuItem, Select, Typography, useTheme } from "@mui/material";
import { IoIosArrowDown } from "react-icons/io";
import { useParams } from "react-router-dom";

const TotalCostOfProject = (propos) => {
    const { kpisData } = propos;
    const theme = useTheme();
    const { projectId } = useParams();

    const actualCost = kpisData?.data?.data?.actualCost ?? 0;
    const totalCost = kpisData?.data?.data?.plannedCost ?? 0;
    const totalDuration = actualCost + totalCost;

    const getWidth = (value) => {
        const percent = (value / totalDuration) * 100;
        return percent <= 0 ? "auto" : `${percent}%`;
    };

    return (
        <Box
            sx={{
                p: "12px",
                border: '1px solid #2525252E',
                borderRadius: '7px',
                height: '204px',
                background: "#FFFFFF",
                width: "100%",
                minHeight: "204px",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                }} >
                <Box>
                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 500,
                            fontSize: '18px',
                            color: `${theme?.customSettings?.themeColor}`,
                            lineHeight: '100%',
                            letterSpacing: '-0.4px'
                        }}
                    >
                        Project Cost
                    </Typography>
                </Box>
                {/* <Box sx={{}}>
                    <Select
                        labelId="demo-simple-select-standard-label"
                        id="demo-simple-select-standard"
                        value={10}
                        IconComponent={IoIosArrowDown}
                        sx={{
                            backgroundColor: "#E8E8E8",
                            "& .MuiOutlinedInput-input": {
                                padding: "5px 15px",
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                        }}
                    >
                        <MenuItem value={10} sx={{ fontWeight: 500, letterSpacing: "-0.4px", fontSize: "16px", color: "#474747" }}>Current month</MenuItem>
                        <MenuItem value={11} sx={{ fontWeight: 500, letterSpacing: "-0.4px", fontSize: "16px", color: "#474747" }}>Prev month</MenuItem>
                    </Select>
                </Box> */}
            </Box>
            <Box>
                <Typography
                    sx={{
                        mt: "11px",
                        color: "#5052588A",
                        fontSize: "14px",
                        lineHeight: "100%",
                        letterSpacing: "-0.4px",
                    }}
                >
                    Tracking actual versus total cost to assess financial health and forecast budget needs
                </Typography>
            </Box>

            <Box sx={{ mt: "13px", p: 1 }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography sx={{
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "100%",
                        letterSpacing: "-0.4px",
                        color: "#182A4E"
                    }}>
                        Total Cost of the project
                    </Typography>
                    <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
                        <Typography
                            sx={{
                                width: 12,
                                height: 12,
                                bgcolor: '#E72B33',
                                borderRadius: '50%',
                            }} />
                        <Typography sx={{
                            fontSize: "13px",
                            fontWeight: 500,
                            lineHeight: "100%",
                            letterSpacing: "-0.4px",
                            color: "#182A4E"
                        }}>
                            Actual Cost
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
                        <Typography
                            sx={{
                                width: 12,
                                height: 12,
                                bgcolor: '#D9D9D9',
                                borderRadius: '50%',
                            }} />
                        <Typography sx={{
                            fontSize: "13px",
                            fontWeight: 500,
                            lineHeight: "100%",
                            letterSpacing: "-0.4px",
                            color: "#182A4E"
                        }}>
                            Total Cost
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ display: "flex", gap: 1, mt: "16px" }}>
                    <Box
                        sx={{
                            width: getWidth(actualCost),
                            backgroundColor: "#CB402D",
                            color: "white",
                            p: 1,
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            height: '33px'
                        }}
                    >
                        <Typography variant="subtitle1">{actualCost}cr</Typography>
                    </Box>

                    <Box
                        sx={{
                            width: getWidth(totalCost),
                            backgroundColor: "#DDDFE3",
                            color: "white",
                            p: 1,
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            height: '33px'
                        }}
                    >
                        <Typography variant="subtitle1">{totalCost}cr</Typography>
                    </Box>
                </Box>
                {/* Legend */}
                <Box sx={{ mt: "12px", mb: 2 }}>
                    {/* <Typography sx={{
                        color: "#182A4E",
                        fontSize: "15px",
                        fontWeight: 500,
                        letterSpacing: "-0.4px",
                        textDecoration: 'underline'
                    }}>
                        View more details
                    </Typography> */}
                </Box>
            </Box>

        </Box >
    );
};

export default TotalCostOfProject;
